import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/DianaShotko_Pet/subs.vtt';
import poster from '@/static/assets/reviews/DianaShotko_Pet/video.jpg';

export const DianaShotko: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet, ReviewProduct.All],
  reviewerName: 'Diana',
  videoUrl: `${ASSETS_URL}/pet/DianaShotko_Pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
